import api from './apiconfig.js';

const API_BASE = api.API_BASE; // Update with your backend URL

const handleResponse = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.message || 'Server error');
    error.payload = payload;
    throw error;
  }
  return payload;
};

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const fetchExpenses = async () => {
  const response = await fetch(`${API_BASE}/expenses`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const fetchExpenseSummary = async () => {
  const response = await fetch(`${API_BASE}/expenses/summary`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const createExpense = async (expense) => {
  const response = await fetch(`${API_BASE}/expenses`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(expense)
  });
  return handleResponse(response);
};

export const updateExpense = async (id, updates) => {
  const response = await fetch(`${API_BASE}/expenses/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(updates)
  });
  return handleResponse(response);
};

export const deleteExpense = async (id) => {
  const response = await fetch(`${API_BASE}/expenses/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const fetchExpenseCategories = async () => {
  const response = await fetch(`${API_BASE}/expenses/categories`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const createExpenseCategory = async (category) => {
  const response = await fetch(`${API_BASE}/expenses/categories`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(category)
  });
  return handleResponse(response);
};

export const updateExpenseCategory = async (id, updates) => {
  const response = await fetch(`${API_BASE}/expenses/categories/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(updates)
  });
  return handleResponse(response);
};

export const deleteExpenseCategory = async (id) => {
  const response = await fetch(`${API_BASE}/expenses/categories/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};
